function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1B6FE1;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "_xF0B0_",
  className: "st0",
  d: "M9.4,16l0.1,0c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7l0,0V7.4l5.7-5.7c0.2-0.2,0.3-0.4,0.3-0.7 c0-0.3-0.1-0.5-0.3-0.7C16,0.1,15.7,0,15.5,0l0,0h-14C1.2,0,0.9,0.1,0.7,0.3S0.5,0.7,0.5,1c0,0.3,0.1,0.5,0.3,0.7l0,0l5.7,5.7v5.8 c0,0.3,0.1,0.6,0.3,0.7l0,0l2,1.7C9,15.9,9.2,16,9.5,16L9.4,16z M9.5,15l-2-1.7V7l-6-6h14l-6,6V15z"
});

var SvgFilterOutline = function SvgFilterOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 16",
    style: {
      enableBackground: "new 0 0 17 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-outline.fef2c596.svg";
export { ForwardRef as ReactComponent };